export const generateTreeData = (data) => {
  return data.map((el) => ({
    ...el,
    isMainParent: true,
    children: el.sub_menu
      ? [
          {
            ...el.sub_menu,
            message: el.sub_menu.message || el.sub_menu.menu_message,
            children: [],
          },
        ]
      : undefined,
  }));
};

export const modifyData = (initialData, newData, parentId, isMainParent = false) => {
  if (isMainParent) {
    return initialData.map((el) => (el.id === newData.id ? newData : el));
  }
  // Buscar el objeto con el parentId
  const parentObj = initialData.find((obj) => obj.id === parentId);

  if (parentObj) {
    // Si newData tiene un id existente, actualizar el objeto correspondiente
    const existingObj = findObjectById(parentObj, newData.id);
    if (existingObj) {
      Object.assign(existingObj, newData);
    } else {
      // Si no existe, agregar newData al array children del objeto padre
      if (!parentObj.children) {
        parentObj.children = [];
      }
      parentObj.children.push(newData);
    }
  } else {
    // Si no se encuentra el objeto padre, buscar en los children recursivamente
    for (const obj of initialData) {
      if (obj.children) {
        modifyData(obj.children, newData, parentId);
      }
    }
  }

  return initialData;
};

const findObjectById = (obj, targetId) => {
  if (obj.id === targetId) {
    return obj;
  }
  if (obj.children) {
    for (const child of obj.children) {
      const found = findObjectById(child, targetId);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

// Ejemplo de uso
const initialData = [
  {
    id: 1,
    children: [
      {
        id: 2,
        name: "Hijo 1",
        children: [
          {
            id: 20,
            name: "otro nivel",
            children: [{ id: 200, name: "otro nivel mas", children: [] }],
          },
        ],
      },
    ],
  },
];

const newData1 = { id: 200, name: "Nuevo nombre para nivel más profundo" };
const parentId1 = 20;
const updatedTree1 = modifyData(initialData, newData1, parentId1);
console.log("actualizado", updatedTree1);

const newData2 = { id: 201, name: "Nuevo hijo para nivel más profundo" };
const parentId2 = 20;
const updatedTree2 = modifyData(initialData, newData2, parentId2);
console.log("creado", updatedTree2);
